module.exports = __webpack_public_path__ + "img/arrow.52222037.svg";